import * as fns from 'date-fns';
import { parseStartDate, parseEndDate } from '../utils/parseDate';

const checkDate = date => {
    const d = new Date(date);
    const limitD = new Date('1975-01-01');
    return d.getTime() >= limitD.getTime();
};

const formatReportHistory = data => {
    const {
        id,
        url,
        firstName,
        lastName,
        isGumGumUser,
        createDate,
        endDate,
        startDate,
        rightsholderSponsorPlacement,
        action,
        heroImagePost,
        // Fields used in SAPI objects
        addedAt,
        name,
        orderBy,
        pdfUrl,
        userDisplayName,
        goal,
    } = data;

    const { id: rightsholder, name: rightsholderName } =
        rightsholderSponsorPlacement.rightsholder;
    const { id: sponsor, name: sponsorName } =
        rightsholderSponsorPlacement.sponsor;
    const { id: placement, name: placementName } =
        rightsholderSponsorPlacement.placement || { id: null, name: null };

    const actionMap = {
        // We translate the source of the report to a Human friendly string
        generateppt: 'PowerPoint',
        generatepdf: 'PDF',
        generatecsv: 'CSV',
    };

    const image = heroImagePost && heroImagePost.cdnMediaUrl;

    const record = {
        id,
        reportUrl: url || pdfUrl,
        addedAt:
            createDate || addedAt
                ? fns.format(createDate || addedAt, 'yyyy-MM-dd HH:mm:ss')
                : undefined,
        rightsholder,
        rightsholderName,
        sponsor,
        sponsorName,
        placement,
        placementName: placementName === 'false' ? '' : placementName,
        startDate: checkDate(startDate) ? parseStartDate(startDate) : undefined,
        endDate: checkDate(endDate) ? parseEndDate(endDate) : undefined,
        exportAs: actionMap[action] || actionMap.generatepdf,
        createdBy: userDisplayName
            ? userDisplayName
            : isGumGumUser
              ? 'Relo'
              : `${firstName} ${lastName}`,
        // Fields used in v2 reporting (Sports report renderer)
        postImgUrl: image,
        name,
        orderBy,
        goal,
    };
    return record;
};

export default formatReportHistory;
